import { render, staticRenderFns } from "./PeopleViewProfileImage.vue?vue&type=template&id=1bf8e5ad&scoped=true&"
import script from "./PeopleViewProfileImage.vue?vue&type=script&lang=js&"
export * from "./PeopleViewProfileImage.vue?vue&type=script&lang=js&"
import style0 from "./PeopleViewProfileImage.vue?vue&type=style&index=0&id=1bf8e5ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8e5ad",
  null
  
)

export default component.exports